/**
 * CVC Customer Styles
 */

import { mergeStyleSets } from "@fluentui/react";
import { CSSProperties } from "react";

export const CVC_CUSTOMER_STYLES = mergeStyleSets({
  root: {
    padding: "12px",
    background: "#FFFFFF"
  } as CSSProperties,
  header: {
    padding: "24px 12px 12px 12px",
    background: "#0078D4",
    color: "#FFFFFF"
  } as CSSProperties,
  headerTitle: {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "4px"
  } as CSSProperties,
  headerSubtitle: {
    fontSize: "14px",
    fontWeight: "400",
    color: "#E8E8E8"
  } as CSSProperties,
  headerLogoBadge: {
    background: "linear-gradient(135deg, #0f3d6e, #2980b9)",
    color: "white",
    borderRadius: "14px",
    padding: "18px 22px",
    fontSize: "20px",
    lineHeight: 1,
    marginRight: "18px",
    boxShadow: "0 4px 12px rgba(15, 61, 110, 0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "7px"
  } as CSSProperties,
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  } as CSSProperties,
  headerBtnSecondary: {
    background: "linear-gradient(135deg, #95a5a6, #7f8c8d)",
    color: "#fff"
  } as CSSProperties,
  pageRoot: {
    background: "#FFFFFF",
    minHeight: "100vh"
  } as CSSProperties,
  pageHeader: {
    background: "rgba(255, 255, 255, 0.97)",
    borderRadius: "14px",
    padding: "18px 28px",
    margin: "18px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)"
  } as CSSProperties,
  pageHeaderTitle: {
    fontSize: "26px",
    fontWeight: 700,
    color: "#0f3d6e",
    lineHeight: 1.2,
    letterSpacing: "-0.4px"
  } as CSSProperties,
  pageHeaderSubtitle: {
    fontSize: "13px",
    fontWeight: 400,
    color: "#7f8c8d",
    lineHeight: "18px",
    marginTop: "4px"
  } as CSSProperties,
  warningBanner: {
    margin: "0 20px 12px 20px"
  } as CSSProperties
});

export const CVC_CUSTOMER_CUSTOMERS_STYLES = mergeStyleSets({
  tabContainer: {
    padding: "0 20px",
    marginTop: "0",
    minHeight: "calc(100vh - 200px)",
    background: "#FFFFFF"
  } as CSSProperties,

  // Filters Section - Blue card matching portal style
  filtersCard: {
    background: "linear-gradient(135deg, rgb(0, 90, 158) 0%, rgb(0, 120, 212) 100%)",
    borderRadius: "12px",
    padding: "16px 20px",
    marginBottom: "16px",
    boxShadow: "0 4px 12px rgba(0, 120, 212, 0.25)"
  } as CSSProperties,

  filtersTitle: {
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 600,
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    gap: "8px"
  } as CSSProperties,

  filtersRow: {
    display: "flex",
    gap: "16px",
    alignItems: "flex-end",
    flexWrap: "wrap"
  } as CSSProperties,

  filterGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: "160px",
    minWidth: "140px",
    flexShrink: 0
  } as CSSProperties,

  filterLabel: {
    color: "#FFFFFF",
    fontSize: "11px",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    opacity: 0.9
  } as CSSProperties,

  clearButton: {
    background: "rgba(255, 255, 255, 0.2)",
    color: "#FFFFFF",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    borderRadius: "6px",
    padding: "8px 20px",
    fontSize: "13px",
    fontWeight: 500,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    transition: "all 0.2s ease",
    height: "36px",
    flexShrink: 0
  } as CSSProperties,

  fullPageLoadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh"
  } as CSSProperties,

  errorContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
    textAlign: "center"
  } as CSSProperties,

  tableSection: {
    background: "#FFFFFF",
    borderRadius: "12px",
    border: "1px solid #E6E9ED",
    padding: "16px"
  } as CSSProperties,

  tableSectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "16px",
    paddingBottom: "12px",
    borderBottom: "1px solid #E6E9ED"
  } as CSSProperties,

  tableSectionTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#0f3d6e",
    margin: 0
  } as CSSProperties,

  tableSectionSubtitle: {
    fontSize: "13px",
    fontWeight: 400,
    color: "#7f8c8d",
    margin: 0
  } as CSSProperties,

  tableSectionIcon: {
    color: "#0078D4",
    fontSize: "18px"
  } as CSSProperties
});
